<template>
  <v-container>
    <v-layout>
      <v-flex lg12>
        <jti-expansion-panel panelName="Add Version">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container grid-list-lg>
              <v-layout wrap>
                <v-text-field
                  v-model="generateVersion"
                  label="Version"
                  :readonly="true"
                  required
                  :value="generateVersion"
                ></v-text-field>
              </v-layout>
              <v-layout wrap>
                <v-text-field
                  v-model="data.purchase_amount"
                  label="Purchase Amount"
                  :readonly="readonly"
                  required
                  :rules="[
                    rules.required,
                    rules.number,
                    rules.minFloor,
                    rules.maxFloor,
                  ]"
                ></v-text-field>
              </v-layout>
              <v-layout wrap>
                <v-text-field
                  v-model="data.credit_amount"
                  label="Credit Amount"
                  :readonly="readonly"
                  required
                  :rules="[
                    rules.required,
                    rules.number,
                    rules.minFloor,
                    rules.maxFloor,
                  ]"
                ></v-text-field>
              </v-layout>
              <v-layout wrap>
                <v-text-field
                  v-model="data.claim_duration"
                  label="Claim Duration"
                  :readonly="readonly"
                  required
                  :rules="[
                    rules.required,
                    rules.numberOnly,
                    rules.minFloor,
                    rules.maxDuration,
                  ]"
                ></v-text-field>
              </v-layout>
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: {
    data: Object,
    readonly: Boolean,
  },
  computed: {
    computedData() {
      return {
        user_id: this.$store.state.employee.id,
        version: this.generateVersion,
        purchase_amount: this.data.purchase_amount,
        credit_amount: this.data.credit_amount,
        claim_duration: this.data.claim_duration,
      };
    },
    generateVersion() {
      const fixHexFormat = (s) => (s.length < 2 ? "0" : "") + s;
      const randomNumber = Math.floor(Math.random() * 255);
      const hexString = randomNumber.toString(16);
      const dateNow = moment().format("YYMMDD");

      return dateNow + fixHexFormat(hexString).toUpperCase();
    },
  },
  data() {
    return {
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        number: (value) => !isNaN(value) || value == "." || "Must be number.",
        numberOnly: (value) => !isNaN(value) || "Must be number.",
        minFloor: (value) => value >= 0 || "The minimum number is 0.",
        maxFloor: (value) => value <= 999 || "The maximum number is 999.",
        maxDuration: (value) => value <= 1095 || "The maximum number is 1095.",
      },
    };
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    validateForm() {
      return this.$refs.form.validate();
    },
  },
};
</script>

<style></style>
